import { Answers } from './answers.model';

export class AppHistory{
    public url:string;
    public Answers:Answers;
    constructor(url:string,answers:Answers)
    {
        this.Answers = answers;
        this.url = url;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/app-history.model.ts